<template>
    <div class="RiskProfileEmptyState">
        <div class="RiskProfileEmptyState__container">
            <span class="RiskProfileEmptyState__title"> Configure your First Risk Profile</span>
            <div class="RiskProfileEmptyState__body">
                <p>
                    <span>A </span>
                    <span class="RiskProfileEmptyState__bodyHighlight">Risk Profile</span>
                    <span> is a set of requirements used to determine the overall risk of your entities.</span>
                </p>
                <p>You can create more than one risk profile and assign entities to different profiles for specific requirements.</p>
            </div>
            <RbacDisableGuard
                v-slot="{ isDisabledByRbac }"
                :features="[RbacFeature.decisioningCreateRiskProfile]"
            >
                <NewButton
                    class="RiskProfileEmptyState__createButton"
                    type="primary"
                    :disabled="isDisabledByRbac"
                    @click="createRiskProfile"
                >
                    Create a Risk Profile
                </NewButton>
            </RbacDisableGuard>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from '@evidentid/vue-property-decorator';

    import RbacDisableGuard
        from '@evidentid/dashboard-commons/modules/role-base-access-control/components/rbac-guard/RbacDisableGuard.vue';
    import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

    import NewButton from '@/components/new-button/NewButton.vue';

    @Component({
        emits: [ 'create' ],
        components: { NewButton, RbacDisableGuard },
    })
    export default class RiskProfileEmptyState extends Vue {
        private createRiskProfile() {
            this.$emit('create');
        }
        // Make RbacFeature available in template
        private RbacFeature = RbacFeature;
    }
</script>
